import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { useAuth0 } from '../../contexts/auth0-context'
import { useMutation } from 'react-query'

type UpdateActivityVariables = {
    activityId: string
    roadmapId: string
    data: Record<string, unknown>
}

export const useUpdateActivityMutation = () => {
    const { getTokenSilently } = useAuth0()

    const updateActivity = async ({ activityId, roadmapId, data }: UpdateActivityVariables) => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        const url = `${endpoints.updateActivity.url}${activityId}/roadmap/${roadmapId}`
        const { method } = endpoints.updateActivity

        const response = await callAPI(url, method, token, data)

        if (!response.success) {
            throw new Error(response.error ?? 'Failed to update activity')
        }

        return response.data
    }

    return useMutation(updateActivity)
}
